<template>
  <Dialog :header="PrintType.HeaderTitle" v-model:visible="PopUpVisible"
    :breakpoints="{ '1199px': '75vw', '575px': '90vw' }" :style="{ width: '80rem' }" :modal="true"
    @after-hide="$emit('closepopup')" maximizable>
    <!-- <div class="my-5 px-5">
      <b-col>
        <Button @click="Print">Print</Button>
      </b-col>

      <iframe :src="ReportUrl" class="iframe-class" loading="lazy"></iframe>
    </div> -->
    <div class="my-5 px-5" v-if="ReportUrl && iframeLoaded">
      <b-col>
        <Button label="Print" severity="success" icon="pi pi-print" class="printbtn" @click="Print" />
      </b-col>
    </div>
    <div class="my-5 px-5">
      <b-row>
        <b-col>
          <iframe :src="ReportUrl" class="iframe-class" loading="lazy" @load="onIframeLoad"></iframe>
        </b-col>
      </b-row>
    </div>

  </Dialog>
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  computed,
  onMounted,
  watch,
  reactive,
} from "vue";

// import { config } from "../../../../../public/config";
import { config } from '../../../../config.js';


export default defineComponent({
  components: {},

  props: {
    ShowAndHide: {
      type: Boolean,
      default: false,
    },
    ParameterValues: {
      type: Object,
    },
    PrintType: {
      type: Object,
      default: {},
    },
  },

  setup(props, { emit }) {
    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData: any;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    const PopUpVisible = ref(false);

    let ReportUrl = ref();
    let ParamVal = ref({
      fromdate: "",
      todate: "",
      Id: 0,
      hospitalid: 0,
      branchid: 0,
      visitreportid: 0,
      receiptcode: '0'
    });

    let PrintType = ref({
      FormId: 0,
      HeaderTitle: "",
      ModuleId: 0,
    });

    watch(props, (newValue: any) => {
      debugger;

      ParamVal.value.Id = newValue.ParameterValues.Id;
      PrintType.value.FormId = newValue.PrintType.FormId;
      PrintType.value.ModuleId = newValue.PrintType.ModuleId;
      ParamVal.value.visitreportid = newValue.ParameterValues.visitreportid;


      if (newValue.PrintType.Type == "T") {
        PrintType.value.HeaderTitle = newValue.PrintType.HeaderTitle;
        ReportsData();
        // Only show popup for Type "T"
        PopUpVisible.value = newValue.ShowAndHide;
      } else if (newValue.PrintType.Type == "S") {
        // For Type "S", just print without showing popup
        Print();
        PopUpVisible.value = false;
      }
    },
      { deep: true }
    );

    let iframeLoaded = ref(false);

    const onIframeLoad = () => {
      iframeLoaded.value = true;
    };

    function ReportsData() {
      debugger;
      ReportUrl.value = "";
      iframeLoaded.value = false;
      ParamVal.value.hospitalid = usersData.OrganizationId;
      ParamVal.value.branchid = usersData.BranchId;

      // ReportUrl.value =
      //   "http://localhost:22463/Webform/WebForm1.aspx?FormId=" +
      //   PrintType.value.FormId +
      //   "&ClientId=" +
      //   usersData.OrganizationId +
      //   "&BranchId=" +
      //   usersData.BranchId +
      //   "&JsonValue=" +
      //   JSON.stringify(ParamVal.value) + "&ModuleId=" + PrintType.value.ModuleId;

      // ReportUrl.value =
      //   "https://moceroreports.convenientcare.life/Webform/WebForm1.aspx?FormId=" +
      //   PrintType.value.FormId +
      //   "&ClientId=" +
      //   usersData.OrganizationId +
      //   "&BranchId=" +
      //   usersData.BranchId +
      //   "&JsonValue=" +
      //   JSON.stringify(ParamVal.value) +
      //   "&ModuleId=" +
      //   PrintType.value.ModuleId;

      // ReportUrl.value =
      //   "https://aravindreports.mocerohealth.com/Webform/WebForm1.aspx?FormId=" +
      //   PrintType.value.FormId +
      //   "&ClientId=" +
      //   usersData.OrganizationId +
      //   "&BranchId=" +
      //   usersData.BranchId +
      //   "&JsonValue=" +
      //   JSON.stringify(ParamVal.value) +
      //   "&ModuleId=" +
      //   PrintType.value.ModuleId;

      // ReportUrl.value =
      //   "https://mopreports.convenientcare.life/Webform/WebForm1.aspx?FormId=" +
      //   PrintType.value.FormId +
      //   "&ClientId=" +
      //   usersData.OrganizationId +
      //   "&BranchId=" +
      //   usersData.BranchId +
      //   "&JsonValue=" +
      //   JSON.stringify(ParamVal.value) +
      //   "&ModuleId=" +
      //   PrintType.value.ModuleId;

      ReportUrl.value =
        config.API_MS_INVENTORY_REPORT_URL +
        "Webform/WebForm1.aspx?FormId=" +
        PrintType.value.FormId +
        "&ClientId=" +
        usersData.OrganizationId +
        "&BranchId=" +
        usersData.BranchId +
        "&JsonValue=" +
        JSON.stringify(ParamVal.value) +
        "&ModuleId=" +
        PrintType.value.ModuleId;
    }

    function Print() {
      debugger;

      ReportUrl.value = "";
      ParamVal.value.hospitalid = usersData.OrganizationId;
      ParamVal.value.branchid = usersData.BranchId;
      // ReportUrl.value =
      //   "http://localhost:22463/Webform/WebForm1.aspx?FormId=" +
      //   PrintType.value.FormId +
      //   "&ClientId=" +
      //   usersData.OrganizationId +
      //   "&BranchId=" +
      //   usersData.BranchId +
      //   "&JsonValue=" +
      //   JSON.stringify(ParamVal.value) + "&ModuleId=" + PrintType.value.ModuleId;

      // ReportUrl.value =
      //   "https://moceroreports.convenientcare.life/Webform/WebForm1.aspx?FormId=" +
      //   PrintType.value.FormId +
      //   "&ClientId=" +
      //   usersData.OrganizationId +
      //   "&BranchId=" +
      //   usersData.BranchId +
      //   "&JsonValue=" +
      //   JSON.stringify(ParamVal.value) +
      //   "&ModuleId=" +
      //   PrintType.value.ModuleId;

      // ReportUrl.value =
      //   "https://aravindreports.mocerohealth.com/Webform/WebForm1.aspx?FormId=" +
      //   PrintType.value.FormId +
      //   "&ClientId=" +
      //   usersData.OrganizationId +
      //   "&BranchId=" +
      //   usersData.BranchId +
      //   "&JsonValue=" +
      //   JSON.stringify(ParamVal.value) +
      //   "&ModuleId=" +
      //   PrintType.value.ModuleId;

      // ReportUrl.value =
      //   "https://mopreports.convenientcare.life/Webform/WebForm1.aspx?FormId=" +
      //   PrintType.value.FormId +
      //   "&ClientId=" +
      //   usersData.OrganizationId +
      //   "&BranchId=" +
      //   usersData.BranchId +
      //   "&JsonValue=" +
      //   JSON.stringify(ParamVal.value) +
      //   "&ModuleId=" +
      //   PrintType.value.ModuleId;

      ReportUrl.value =
        config.API_MS_INVENTORY_REPORT_URL +
        "Webform/WebForm1.aspx?FormId=" +
        PrintType.value.FormId +
        "&ClientId=" +
        usersData.OrganizationId +
        "&BranchId=" +
        usersData.BranchId +
        "&JsonValue=" +
        JSON.stringify(ParamVal.value) +
        "&ModuleId=" +
        PrintType.value.ModuleId;

      window.open(ReportUrl.value, "_blank");
    }

    return { PopUpVisible, ReportUrl, Print, PrintType, iframeLoaded, onIframeLoad };
  },
});


</script>

<style lang="scss" scoped></style>
